import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace AKCCanineGoodCitizen {
  export const form: IEventRegisterRow[] = [
    {
      allowDuplicates: false,
      inputs: [
        {
          type: "checkbox",
          label: Constants.dog_class_element.cgc,
          multiSelect: true,
          options: [
            {
              value: Constants.dog_class_element_level.canine_good_citizen,
              id: Constants.dog_class_element_level.canine_good_citizen,
            },
            {
              value: Constants.dog_class_element_level.canine_good_citizen_advanced,
              id: Constants.dog_class_element_level.canine_good_citizen_advanced,
            },
            {
              value: Constants.dog_class_element_level.canine_good_citizen_urban,
              id: Constants.dog_class_element_level.canine_good_citizen_urban,
            },
          ],
        },
      ],
    },
  ];
}
